import { fetchApi } from '../lib/apiClient';
import { Folder, CreateFolderDto, UpdateFolderDto } from '../types/folder';

/**
 * 文件夹服务类
 * 提供文件夹相关的 API 调用方法
 */
export class FolderService {
  /**
   * 获取文件夹列表
   */
  static async getFolders(): Promise<Folder[]> {
    return await fetchApi<Folder[]>('/folder', { method: 'GET' });
  }

  /**
   * 创建新文件夹
   */
  static async createFolder(folderData: CreateFolderDto): Promise<Folder> {
    return await fetchApi<Folder>('/folder', {
      method: 'POST',
      body: folderData,
    });
  }

  /**
   * 更新文件夹
   */
  static async updateFolder(folderData: UpdateFolderDto): Promise<Folder> {
    return await fetchApi<Folder>(`/folder/${folderData.id}`, {
      method: 'PUT',
      body: { name: folderData.name },
    });
  }

  /**
   * 删除文件夹
   */
  static async deleteFolder(folderId: string): Promise<void> {
    return await fetchApi<void>(`/folder/${folderId}`, {
      method: 'DELETE',
    });
  }
}
